import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "invalid"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Input from '../Input';
import { useDeprecated } from '../hooks';
const Root = styled(Input).withConfig({
  displayName: "TextArea__Root",
  componentId: "sc-1oyodbc-0"
})(["padding:0;height:auto;textarea{min-width:298px;min-height:40px;padding:var(--size-spacing-02) var(--size-spacing-04) var(--size-spacing-02) var(--size-spacing-03);", ";}"], _ref => {
  let {
    nonResizable
  } = _ref;
  return nonResizable && css(["resize:none;"]);
});
const TextArea = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
      children,
      invalid
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
  useDeprecated({
    invalid,
    originName: 'TextArea'
  });
  return /*#__PURE__*/React.createElement(Root, _extends({
    forwardedAs: "textarea",
    ref: ref,
    invalid: invalid
  }, rest), children);
});
TextArea.displayName = 'TextArea';
TextArea.Style = Root;
TextArea.defaultProps = {
  rows: 2,
  disabled: false,
  nonResizable: false,
  required: false
};
process.env.NODE_ENV !== "production" ? TextArea.propTypes = {
  /**
   * Sets if is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * Sets the placeholder.
   */
  placeholder: PropTypes.string,
  /**
   * Sets if the textarea can't be resized.
   */
  nonResizable: PropTypes.bool,
  /**
   * Sets the prefix.
   */
  prefix: PropTypes.node,
  /**
   * Sets if is required.
   */
  required: PropTypes.bool,
  /**
   * Sets the number of rows should be rendered.
   */
  rows: PropTypes.number,
  /**
   * Sets the suffix.
   */
  suffix: PropTypes.node,
  /**
   * Sets the value.
   */
  value: PropTypes.node,
  /**
   * @deprecated - Use with `Form.Control` to set error/invalid style.
   *
   * Sets if is invalid
   */
  invalid: PropTypes.bool
} : void 0;
export default TextArea;